import React, { useEffect, useRef, useState } from 'react';
import '../../../../Assets/Css/ViewEmpTask.scss';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import Table from '../../../../Components/Table';
import { LuPlusCircle } from "react-icons/lu";
import Select from 'react-select'
import { customStyle } from '../../../../Components/Style'
import DatePicker from 'react-datepicker';
import ProfilePic from '../../../../Assets/Images/Employee/testimonial-3.jpg';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ImCheckmark } from "react-icons/im";
import { FaClock } from "react-icons/fa";
import { BsPauseCircleFill } from "react-icons/bs";
import { FaStopCircle } from "react-icons/fa";

const initialState = {
    title: null,
    assignto: null,
    name: '',
    startdate: null,
    enddate: null,
}

const ViewEmpTask = (props) => {
    const [activeTab, setActiveTab] = useState('files');
    const [inData, setInData] = useState([]);
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [clientData, setClientData] = useState(initialState);
    const [showInput, setShowInput] = useState(false);
    const [fileName, setFileName] = useState('');
    const fileInputRef = useRef(null);
    const navigate = useNavigate();

    const header = [
        { field: 'Employee' },
        { field: 'Start Time' },
        { field: 'End Time' },
        { field: 'Memo' },
        { field: 'Hours Logged' },
    ];

    const AssignTo = [
        { value: 'Employee 1', label: 'Employee 1' },
        { value: 'Employee 2', label: 'Employee 2' },
        { value: 'Employee 3', label: 'Employee 3' },
        { value: 'Employee 4', label: 'Employee 4' },
        { value: 'Employee 5', label: 'Employee 5' },
    ];

    let footer = true;
    let count = props?.purchaseInvoice?.length;

    useEffect(() => {
        props?.purchaseInvoice
            ? setInData(
                props?.purchaseInvoice?.map((purchaseinvoice) => {
                    return {

                        "Employee": {
                            value: '123',
                            type: 'text',
                        },
                        "Start Time": {
                            value: 'CD_123',
                            type: 'text',
                        },
                        "End Time": {
                            value: 'Camelab Dashboard Module',
                            type: 'text',
                        },
                        "Memo": {
                            value: 'Camelab',
                            type: 'text',
                        },
                        'Hours Logged': {
                            value: '10h 45m',
                            type: 'date',
                        },
                    };
                })
            )
            : setInData([]);
    }, [props?.purchaseInvoice, props?.systemsettings]);

    const showFields = () => setShowInput(true);
    const hideFields = () => setShowInput(false);


    const fileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            setFileName(file.name);
        }
    };

    const fileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleChange = (e) => {
        if (e[1] == 'headerAll' && e[0] === true) {
            setTotalSelectedIds([...e[2]]);
        } else if (e[0] === true && e[1] !== 'headerAll') {
            setTotalSelectedIds([...totalSelectedIds, e[1]]);
        } else if (e[1] == 'headerAll' && e[0] === false) {
            setTotalSelectedIds([]);
        } else {
            let filterdId = totalSelectedIds.filter((item) => {
                return item != e[1];
            });
            setTotalSelectedIds(filterdId);
        }
    };

    const handleSubmit = async () => {
        navigate("/project/employeeproject/view/task");
    };

    return (
        <div className="viewEmpTask-main">
            <div className="page-title">
                <h4> Task Info </h4>
            </div>
            <div className="content-part">
                <div className="row">
                    <div className="col-lg-9">
                        <div className="left-part">
                            <div className="custom-row">
                                <div className="task-detail">
                                    {/* <h5 className="emptask-detail-divider"> Task Details </h5> */}
                                    <div className="all-btn">
                                        <button type="submit" className="custom-mark-btn" onClick={() => navigate('/task/emptask')}>
                                            {props.loading ? (
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    className="custom-spinner"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                            ) : (
                                                <div className='timer-content'>
                                                    <ImCheckmark className='me-2' /> Mark As Complete
                                                </div>
                                            )}
                                        </button>

                                        <button type="submit" className="btn-timer" onClick={() => toast.success("Timer : 03:52:30")}>
                                            {props.loading ? (
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    className="custom-spinner"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                            ) : (
                                                <div className='timer-content'>
                                                    <FaClock className='me-2' /> 03:52:30
                                                </div>
                                            )}
                                        </button>

                                        <button type="submit" className="btn-cancel" onClick={() => toast.success("Timer Paused")}>
                                            {props.loading ? (
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    className="custom-spinner"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                            ) : (
                                                <div className='timer-content'>
                                                    <BsPauseCircleFill className='me-2' /> Pause Timer
                                                </div>

                                            )}
                                        </button>

                                        <button type="submit" className="btn-cancel" onClick={() => toast.success("Timer Stop")}>
                                            {props.loading ? (
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    className="custom-spinner"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                            ) : (
                                                <div className='timer-content'>
                                                    <FaStopCircle className='me-2' /> Stop Timer
                                                </div>
                                            )}
                                        </button>
                                    </div>
                                    <h5 className="emptask-detail-divider" />
                                    <div className="row">
                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className="labels">Project</h6>
                                            </div>
                                            <div className="col-9">
                                                <h6 className="labels">Camelab</h6>
                                            </div>
                                        </div>

                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className="labels">Priority</h6>
                                            </div>
                                            <div className="col-9">
                                                <h6 className="labels">Medium</h6>
                                            </div>
                                        </div>

                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className="labels">Assign To</h6>
                                            </div>
                                            <div className="col-9">
                                                <div className="profile-section">
                                                    <img src={ProfilePic} alt="Profile Pic" className="task-pic" />
                                                    <div className="profile-info">
                                                        <h6 className="labels">ABCD</h6>
                                                        <h6 className="labels">Developer</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className="labels">Short Code</h6>
                                            </div>
                                            <div className="col-9">
                                                <h6 className="labels">CD_123</h6>
                                            </div>
                                        </div>

                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className="labels">Assigned By</h6>
                                            </div>
                                            <div className="col-9">
                                                <div className="profile-section">
                                                    <img src={ProfilePic} alt="Profile Pic" className="task-pic" />
                                                    <div className="profile-info">
                                                        <h6 className="labels">ABCD</h6>
                                                        <h6 className="labels">Developer</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className="labels">Label</h6>
                                            </div>
                                            <div className="col-9">
                                                <h6 className="labels">---</h6>
                                            </div>
                                        </div>

                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className="labels">Task Category</h6>
                                            </div>
                                            <div className="col-9">
                                                <h6 className="labels">Development</h6>
                                            </div>
                                        </div>

                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className="labels">Description</h6>
                                            </div>
                                            <div className="col-9">
                                                <h6 className="labels">HRMS Task Module</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3">
                        <div className="left-part">
                            <div className="custom-row">
                                <div className="task-detail">
                                    <h5 className="task-detail-divider"> Doing </h5>
                                    <div className="row">
                                        <div className="input-groups">
                                            <div className="col-6">
                                                <h6 className="labels">Start Date</h6>
                                            </div>
                                            <div className="col-6">
                                                <h6 className="labels">01-01-2024</h6>
                                            </div>
                                        </div>

                                        <div className="input-groups">
                                            <div className="col-6">
                                                <h6 className="labels">Due Date</h6>
                                            </div>
                                            <div className="col-6">
                                                <h6 className="labels">02-01-2024</h6>
                                            </div>
                                        </div>

                                        <div className="input-groups">
                                            <div className="col-6">
                                                <h6 className="labels">Hours Logged</h6>
                                            </div>
                                            <div className="col-6">
                                                <h6 className="labels">10h 51m</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content-part">
                <div className="row">
                    <div className="col-lg-9">
                        <div className="left-part">
                            <div className="custom-row">
                                <div className="project-detail">
                                    <div className="viewtask-tab-buttons">
                                        <div
                                            className={`viewtask-tab-item ${activeTab === 'files' ? 'active-tab' : ''
                                                }`}
                                        >
                                            <button
                                                className="viewtask-tab-link"
                                                onClick={() => setActiveTab('files')}
                                            >
                                                Files
                                            </button>
                                        </div>

                                        <div
                                            className={`viewtask-tab-item ${activeTab === 'subtask' ? 'active-tab' : ''
                                                }`}
                                        >
                                            <button
                                                className="viewtask-tab-link"
                                                onClick={() => setActiveTab('subtask')}
                                            >
                                                Sub Task
                                            </button>
                                        </div>

                                        <div
                                            className={`viewtask-tab-item ${activeTab === 'comment' ? 'active-tab' : ''
                                                }`}
                                        >
                                            <button
                                                className="viewtask-tab-link"
                                                onClick={() => setActiveTab('comment')}
                                            >
                                                Comment
                                            </button>
                                        </div>

                                        <div
                                            className={`viewtask-tab-item ${activeTab === 'timesheet' ? 'active-tab' : ''
                                                }`}
                                        >
                                            <button
                                                className="viewtask-tab-link"
                                                onClick={() => setActiveTab('timesheet')}
                                            >
                                                Timesheet
                                            </button>
                                        </div>

                                        <div
                                            className={`viewtask-tab-item ${activeTab === 'notes' ? 'active-tab' : ''
                                                }`}
                                        >
                                            <button
                                                className="viewtask-tab-link"
                                                onClick={() => setActiveTab('notes')}
                                            >
                                                Notes
                                            </button>
                                        </div>

                                        <div
                                            className={`viewtask-tab-item ${activeTab === 'history' ? 'active-tab' : ''
                                                }`}
                                        >
                                            <button
                                                className="viewtask-tab-link"
                                                onClick={() => setActiveTab('history')}
                                            >
                                                History
                                            </button>
                                        </div>

                                    </div>

                                    {activeTab === 'files' && (
                                        <div className='subtask-row'>
                                            <div className='d-flex flex-row'>
                                                <div className="add-sub-task" onClick={fileInput}>
                                                    <LuPlusCircle className='fs-5' />
                                                    <h6 className="ms-2 mt-2">Upload File</h6>
                                                </div>
                                                {fileName && <span className="ms-4 mt-1">{fileName}</span>}
                                            </div>
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                style={{ display: 'none' }}
                                                onChange={fileChange}
                                            />
                                        </div>
                                    )}

                                    {activeTab === 'subtask' && (
                                        <div className='subtask-row'>

                                            {!showInput ? (
                                                <div className="add-sub-task" onClick={showFields}>
                                                    <LuPlusCircle className='fs-5' />
                                                    <h6 className="ms-2 mt-2">Add Sub Task</h6>
                                                </div>
                                            ) : (
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="input-group">
                                                            <h6 className='label'>Title</h6>
                                                            <input type="text" className="input-css" name='title' placeholder="Enter a task title" />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-4">
                                                        <div className="input-group">
                                                            <h6 className='label'>Start Date</h6>
                                                            <DatePicker
                                                                selected={clientData.startdate ? new Date(clientData.startdate) : null}
                                                                onChange={(date) => {
                                                                    setClientData((preVal) => ({
                                                                        ...preVal,
                                                                        startdate: date ? date.toISOString().split('T')[0] : '',
                                                                    }));
                                                                }}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                name="transaction_date"
                                                                disabled={props.loading}
                                                                customInput={<input className="input-css" />}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: "#5757fe",
                                                                        primary: "#5757fe",
                                                                    },
                                                                })}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-4">
                                                        <div className="input-group">
                                                            <h6 className='label'>End Date</h6>
                                                            <DatePicker
                                                                selected={clientData.enddate ? new Date(clientData.enddate) : null}
                                                                onChange={(date) => {
                                                                    setClientData((preVal) => ({
                                                                        ...preVal,
                                                                        enddate: date ? date.toISOString().split('T')[0] : '',
                                                                    }));
                                                                }}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                name="transaction_date"
                                                                disabled={props.loading}
                                                                customInput={<input className="input-css" />}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: "#5757fe",
                                                                        primary: "#5757fe",
                                                                    },
                                                                })}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-4">
                                                        <div className="input-group">
                                                            <h6 className='label'>Assign To</h6>
                                                            <Select
                                                                options={AssignTo}
                                                                styles={{
                                                                    ...customStyle,
                                                                    menu: (provided) => ({
                                                                        ...provided,
                                                                        zIndex: 2,
                                                                    }),
                                                                }}
                                                                value={clientData.assignto}
                                                                placeholder="---"
                                                                onChange={(val) => {
                                                                    setClientData((preVal) => ({
                                                                        ...preVal,
                                                                        assignto: val
                                                                    }))
                                                                }}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: "#5757fe",
                                                                        primary: "#5757fe",
                                                                    },
                                                                })}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12">
                                                        <div className="input-group">
                                                            <h6 className="label">Description</h6>
                                                            <textarea
                                                                rows="4"
                                                                cols="50"
                                                                className="form-control input-css"
                                                                style={{ width: '100%' }}
                                                                name="address"
                                                                placeholder="Description"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="edit-btn d-flex justify-content-end">
                                                        <button
                                                            type="submit"
                                                            className="btn-cancel"
                                                            onClick={hideFields}
                                                        >
                                                            {props.loading ? (
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    className="custom-spinner"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                />
                                                            ) : (
                                                                "Cancel"
                                                            )}
                                                        </button>

                                                        <button
                                                            type="submit"
                                                            className="custom-btn"
                                                            onClick={handleSubmit}
                                                        >
                                                            {props.loading ? (
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    className="custom-spinner"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                />
                                                            ) : (
                                                                "Submit"
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            )}

                                        </div>
                                    )}

                                    {activeTab === 'comment' && (
                                        <div className='subtask-row'>
                                            <div className="add-sub-task">
                                                <LuPlusCircle className='fs-5' />
                                                <h6 className="ms-2 mt-2">Add Comment</h6>
                                            </div>
                                        </div>
                                    )}

                                    {activeTab === 'timesheet' && (
                                        <div className='timesheet-row'>
                                            <div className="invoice-table-part">
                                                <Table
                                                    header={header}
                                                    data={inData}
                                                    footer={footer}
                                                    count={count}
                                                    records={count}
                                                    handleChange={handleChange}
                                                    loading={props.loading}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {activeTab === 'notes' && (
                                        <div className='subtask-row'>
                                            <div className="add-sub-task">
                                                <LuPlusCircle className='fs-5' />
                                                <h6 className="ms-2 mt-2">Add Note</h6>
                                            </div>
                                        </div>
                                    )}

                                    {activeTab === 'history' && (
                                        <div className='history-row'>
                                            <div className="input-groups">
                                                <div className="col-1">
                                                    <img src={ProfilePic} className='task-history-image' />
                                                </div>
                                                <div className="col-11">
                                                    <h6 className='labels-heading'>Timer Started Kuntesh Kothiya</h6>
                                                    <h6 className='labels'>01-06-2024 3:30 pm</h6>
                                                </div>
                                            </div>

                                            <div className="input-groups">
                                                <div className="col-1">
                                                    <img src={ProfilePic} className='task-history-image' />
                                                </div>
                                                <div className="col-11">
                                                    <h6 className='labels-heading'>Timer Stopped Kuntesh Kothiya</h6>
                                                    <h6 className='labels'>01-06-2024 3:30 pm</h6>
                                                </div>
                                            </div>

                                            <div className="input-groups">
                                                <div className="col-1">
                                                    <img src={ProfilePic} className='task-history-image' />
                                                </div>
                                                <div className="col-11">
                                                    <h6 className='labels-heading'>Timer Started Kuntesh Kothiya</h6>
                                                    <h6 className='labels'>01-06-2024 3:30 pm</h6>
                                                </div>
                                            </div>

                                            <div className="input-groups">
                                                <div className="col-1">
                                                    <img src={ProfilePic} className='task-history-image' />
                                                </div>
                                                <div className="col-11">
                                                    <h6 className='labels-heading'>Timer Stopped Kuntesh Kothiya</h6>
                                                    <h6 className='labels'>01-06-2024 3:30 pm</h6>
                                                </div>
                                            </div>

                                            <div className="input-groups">
                                                <div className="col-1">
                                                    <img src={ProfilePic} className='task-history-image' />
                                                </div>
                                                <div className="col-11">
                                                    <h6 className='labels-heading'>Timer Started Kuntesh Kothiya</h6>
                                                    <h6 className='labels'>01-06-2024 3:30 pm</h6>
                                                </div>
                                            </div>

                                            <div className="input-groups">
                                                <div className="col-1">
                                                    <img src={ProfilePic} className='task-history-image' />
                                                </div>
                                                <div className="col-11">
                                                    <h6 className='labels-heading'>Timer Stopped Kuntesh Kothiya</h6>
                                                    <h6 className='labels'>01-06-2024 3:30 pm</h6>
                                                </div>
                                            </div>

                                            <div className="input-groups">
                                                <div className="col-1">
                                                    <img src={ProfilePic} className='task-history-image' />
                                                </div>
                                                <div className="col-11">
                                                    <h6 className='labels-heading'>Timer Started Kuntesh Kothiya</h6>
                                                    <h6 className='labels'>01-06-2024 3:30 pm</h6>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        loading: state.clientsReducer.loading,
        shareholdersList: state.shareholdersReducer.shareholderslist,
        invoicesList: state.invoicesReducer.invoiceslist,
        systemsettings: state.invoicesReducer.systemsettings,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getShareholdersList: () => {
            dispatch(getShareholdersList());
        },
        getInvoicesList: () => {
            dispatch(getInvoicesList());
        },
        addClient: (data) => {
            dispatch(addClient(data));
        },
        updateClients: (id, data) => {
            dispatch(updateClients(id, data));
        },
        getSystemSettings: () => {
            dispatch(getSystemSettings());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewEmpTask);